import { ThemeDefinition, VuetifyOptions } from 'vuetify';

const blackColor = '#212121';
const primaryRedColor = '#DB2017';
const whiteColor = '#FFFFFF';

const grey500Color = '#979797';
const grey300Color = '#BFBFBF';

const dpmprLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#FF0000',
    info: '#2196F3',
    primary: primaryRedColor,
    secondary: whiteColor,
    success: '#388E3C',
    warning: '#FB8C00',
    background: whiteColor,
    'on-surface': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor,
    systemPrimary: primaryRedColor,
    systemToolbar: primaryRedColor,
    navigationDrawer: primaryRedColor,
    neutral: grey500Color,
    'neutral-light': whiteColor,
    'neutral-border': grey300Color,
    'on-navigationDrawer': '#4A4A4A',
    'on-systemToolbar': whiteColor,
  },
};

export const dpmprTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: dpmprLightTheme,
  },
};
